import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-chart-granularity-selector',
  templateUrl: './chart-granularity-selector.component.html',
  styleUrls: ['./chart-granularity-selector.component.sass']
})
export class ChartGranularitySelectorComponent implements OnInit {
  @Input()  granularity = 'monthly';
  @Input()  year =  new Date().getFullYear();
  @Input()  month = new Date().getMonth() + 1;
  @Output() changeFilters = new EventEmitter();

  filtersShown = false;
  filters = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    granularity: 'monthly',
  };

  constructor() { }

  ngOnInit() {
  }

  onConfirmFilter() {
    this.filtersShown = false;
    this.changeFilters.emit({
      year: this.filters.year,
      granularity: this.filters.granularity,
      month: this.filters.month,
    });
  }

  onCancelFilter() {
    this.filtersShown = false;
    this.filters.year = this.year;
    this.filters.granularity = this.granularity;
    this.filters.month =  this.month;
  }

  onToggleFilters() {
    this.filtersShown = !this.filtersShown;
  }

  onClickGranularity() {
    if (this.filters.granularity === 'daily') {
      this.filters.granularity = 'monthly';
    } else {
      this.filters.granularity = 'daily';
    }
  }

  onPrevMonth() {
    this.filters.month--;

    if (this.filters.month === 0) {
      this.filters.month = 12;
    }
  }

  onNextMonth() {
    this.filters.month++;

    if (this.filters.month > 12) {
      this.filters.month = 1;
    }
  }

  onPrevYear() {
    this.filters.year--;
  }

  onNextYear() {
    if (this.filters.year < new Date().getFullYear()) {
      this.filters.year++;
    }
  }

  hasPrevYear() {
    return true;
  }

  hasNextYear() {
    return this.filters.year < new Date().getFullYear();
  }
}
